// src/components/strumenti/GiorniRegistrazioneTVCC.js — W442. Giorni di registrazione con un disco dato
import React from "react";
import { useCampi, Campo, Griglia, Risultato, Formula, Azzera, fmt } from "./UiStrumento";
import { giorniRegistrazione } from "../../utils/calcoliStrumenti";

export default function GiorniRegistrazioneTVCC() {
  const { v, set, n, azzera } = useCampi({ tb:"", tel:"", mbps:"", ore:"24" });
  const r = giorniRegistrazione(n("tb"), n("tel"), n("mbps"), n("ore"));
  return (
    <div>
      <Griglia colonne={2}>
        <Campo etichetta="Capacità del disco (TB)" valore={v.tb} onChange={set("tb")} placeholder="Es. 4" aiuto="TB decimali, come indicato sul disco."/>
        <Campo etichetta="Numero di telecamere" valore={v.tel} onChange={set("tel")} placeholder="Es. 8"/>
        <Campo etichetta="Bitrate per telecamera (Mbit/s)" valore={v.mbps} onChange={set("mbps")} placeholder="Es. 4"/>
        <Campo etichetta="Ore di registrazione al giorno" valore={v.ore} onChange={set("ore")} placeholder="24"/>
      </Griglia>
      <Risultato settore="tvcc" titolo="Giorni di registrazione" valore={fmt(r?.giorni, 1)} unita="giorni"
        righe={r ? [["Spazio occupato al giorno", fmt(r.gbGiorno, 1) + " GB"]] : []}/>
      <Formula>Giorni = TB × 10¹² × 8 ÷ (telecamere × Mbit/s × 10⁶ × 3600 × ore al giorno). Bitrate costante; con registrazione su movimento i giorni aumentano. Una parte del disco è usata dal sistema: tieni un margine. Ricorda i limiti di conservazione previsti per la videosorveglianza.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
